import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Younes Raymond </span>
            from <span className="purple"> Rabat, Morocco.</span>
            <br />
            I am a Software Engineer currently working on multiple projects, including developing and managing
            <span className="purple"> SaaS solutions</span> and collaborating with various companies.
            <br />
            I hold an Integrated MSc (IMSc) in Maths and Computing from BIT Mesra. Additionally, I am
            certified by <span className="purple">HackerRank</span> for my problem-solving skills and contributions.
            <br />
            <br />
            Apart from coding, I enjoy solving complex problems and engaging in various activities:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgba(53, 136, 93, 0.928)" }}>
            "Strive to build things that make a difference!"
          </p>
          <footer className="blockquote-footer"  >Younes Raymond</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
